import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";

export default function CreateRole({ showRole, closeModal, refreshPage }) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    role: "",
    description: "",
  });

  const resetForm = () => {
    setFormData({
      role: "",
      description: "",
    });
    setValidationError({});
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    try {
      await axiosInstance.post("/user/roles/create", formData);
      handleClose();
      refreshPage();
      toast.success("Role saved successfully!");
    } catch (error) {
      if (error.response && error.response.data.errors) {
        setValidationError(error.response.data.errors);
        toast.error("Failed to save user.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="CreateUserMngt">
      <Modal show={showRole} onHide={handleClose} dialogClassName="modal-lg">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">Role Name</span>
                </div>
                <Form.Control
                  type="text"
                  placeholder="Enter role name"
                  name="role"
                  value={formData.role}
                  onChange={(e) =>
                    setFormData({ ...formData, role: e.target.value })
                  }
                  required
                />
              </div>

              {validationError.role && (
                <small className="text-danger">{validationError.role[0]}</small>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">Role Description</span>
                </div>
                <Form.Control
                  type="text"
                  placeholder="Enter description"
                  name="description"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  required
                />
              </div>

              {validationError.description && (
                <small className="text-danger">
                  {validationError.description[0]}
                </small>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              style={{
                backgroundColor: "#c4281b",
                color: "#fff",
                border: "none",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
